import { render, staticRenderFns } from "./StartingOrderView.vue?vue&type=template&id=cb1cafa2"
import script from "./StartingOrderView.vue?vue&type=script&lang=js"
export * from "./StartingOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports